import type { ValueOf } from '@mathflat/shared/@types/utilityTypes'

export const STUDENT_WORKBOOK_LIST_TYPE = {
  일반교재: 'general',
  시그니처교재: 'custom-signature',
  학원그룹교재: 'academy-group',
} as const

export type StudentWorkbookListType = ValueOf<typeof STUDENT_WORKBOOK_LIST_TYPE>

const isStudentWorkbookListType = (value: unknown): value is StudentWorkbookListType =>
  (Object.values(STUDENT_WORKBOOK_LIST_TYPE) as unknown[]).includes(value)

/**
 * 경로 파라미터 값을 교재 목록 타입으로 해석한다.
 * 주소창으로 임의 값이 들어올 수 있으므로 미지 값·누락은 일반교재로 두고 폴백 이동을 지시한다.
 */
export const resolveStudentWorkbookListType = (
  value: unknown,
): { type: StudentWorkbookListType; needsFallback: boolean } =>
  isStudentWorkbookListType(value)
    ? { type: value, needsFallback: false }
    : { type: STUDENT_WORKBOOK_LIST_TYPE.일반교재, needsFallback: true }

export const studentWorkbookListPathParams = {
  studentWorkbookListType: 'studentWorkbookListType',
} as const
export type StudentWorkbookDetailPathParamT = {
  readonly studentWorkbookId: string
  readonly revisionId: string
  readonly pageNumber: string
}

export type StudentWorkbookPathParamT = {
  readonly [K in (typeof studentWorkbookListPathParams)['studentWorkbookListType']]: StudentWorkbookListType
}
